// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__36Z7R","container":"styles_container__2xZNZ","title":"styles_title__2bsFK","wrapper":"styles_wrapper__-ZEh_","answer":"styles_answer___lg14"};